import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";
import { getRouteApi } from "@tanstack/react-router";

import { ORDER_LIST_PER_PAGE_LIMIT } from "../../constants";
import type { SendCredentialsRequestDto } from "../../dtos/send-credentials-request-dto";
import type { SendCredentialsResponseDto } from "../../dtos/send-credentials-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UsePutSendCredentialsMutationProps = {
  options?: UseMutationOptions<
    SendCredentialsResponseDto,
    unknown,
    SendCredentialsRequestDto
  >;
};

const router = getRouteApi("/orders/");

export const usePutSendCredentialsMutation = ({
  options
}: UsePutSendCredentialsMutationProps = {}) => {
  const queryClient = useQueryClient();
  const { page, status, q, start_date, end_date } = router.useSearch();

  return useMutation({
    mutationFn: async (payload) => {
      return await OrderService.sendCredentials({ payload });
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: OrderQueryKeys.getOrderList({
          page,
          order_status: status,
          q,
          limit: ORDER_LIST_PER_PAGE_LIMIT,
          start_date,
          end_date
        }).queryKey
      });
      queryClient.invalidateQueries({
        queryKey: OrderQueryKeys.getOrderCount({
          q,
          start_date,
          end_date
        }).queryKey
      });
      options?.onSuccess?.(...args);
    },
    ...options
  });
};
